module.exports = __webpack_public_path__ + "img/amx-18.883dc980.jpg";